import { z } from 'zod';

export type DocumentscopyInfo = z.infer<typeof DocumentscopyInfoSchema>;

export const DocumentscopyInfoSchema = z.object({
  key: z.string(),
  documentType: z.string().toUpperCase(),
  signerAddress: z.string().nullable(),
  status: z.string().nullable(),
  evidences: z.array(z.object({
    url: z.string().nullable(),
    capturedAt: z.string().transform((value) => value ?? new Date().toISOString()).nullable(),
    kind: z.string().nullable(),
    name: z.string().nullable(),
  }).nullable()),
});
